<template>
  <div>
    <p class="contenttext">
      <br >客户成功案例
    </p>
    <div class="introducecard-frame">
      <div v-for="(item,index) in arr3" :key="index" class="introducecard2">
        <div class="image3">
          <img :src="item.link" alt="">
        </div>
        <div :class="{hoverChange2:nowindex3 === index}" class="introduceText3" @mouseenter="mouseOver3(index)" @mouseleave="mouseLeave3(index)">
          <div class="card-title3"><h4>{{ item.title }}</h4></div>
          <div class="card-text3">{{ item.content }}</div>
          <!-- <a>
            <router-link class="mybtn" to="/successcase">案例详情</router-link>
          </a> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Introducecard',
  props: {
    arr3: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      nowindex3: 0
    }
  },
  methods: {
    mouseOver3: function(x) {
      this.nowindex3 = x
    },
    mouseLeave3: function(x) {
      this.nowindex3 = -1
    }
  }
}
</script>
<style scoped>
.contenttext {
  color: rgb(0, 0, 0);
  font-size: 32px;
  text-align: center;
  padding: 6%;
  padding-top: 4%;
  margin:0;
}

.introducecard-frame{
  display: flex;
  flex-wrap: wrap;
}

.introducecard2 {
  /* background-color: rgba(243, 241, 235, 0.473); */
  background-color:rgba(247,247,247,1);
  height:340px;
  width:584px;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  margin:0px 8px 20px 8px;
  transition: 0.4s all ease;
}

.introduceText3 {
  background-color: rgb(255, 255, 255);
  position: absolute;
  bottom:0;
  transition: all 0.4s;
  height: 140px;
  width: 100%;
  padding:4%;
}

.introducecard2:hover {
  box-shadow:0px 20px 800px 0px rgba(18,32,46,0.3);
  z-index: 2;
}
.introducecard2:hover .introduceText3 {
  height: 200px;
  transition:0.4s;
}

.introducecard2:hover .mybtn {
  height:40px;
}

.card-title3 {
  margin-top: 1%;
  text-align: left;
}

.card-text3 {
  font-size: 14px;
  text-align: left;
}

.introducecard2 img {
  width:100%;
}

.mybtn {
    text-align: center;
    width: 100px;
    height: 0;
    line-height: 40px;
    font-size: 14px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: #0086f1;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 20px;
    top:120px;
}
</style>



// WEBPACK FOOTER //
// src/components/introducecard.vue